import filter from 'lodash/filter';
import APIService from '../APIService';
import { API_HOST, apiEndpoints } from '../../constants/APIConstants';

const isBangalore = cityId => {
  return cityId === process.env.REACT_APP_BANGALORE_CITY_ID;
};

export function getHomeCities() {
  return new Promise((resolve, reject) => {
    APIService.request(
      {
        method: 'GET',
        url: `${API_HOST}${apiEndpoints.CITIES}`,
      },
      (error, data) => {
        if (error) {
          reject(error);
        } else if (data) {
          resolve(data);
        } else {
          resolve(null);
        }
      }
    );
  });
}

export function getJobCities() {
  return new Promise((resolve, reject) => {
    APIService.request(
      {
        method: 'GET',
        url: `${API_HOST}${apiEndpoints.CITIES}`,
      },
      (error, data) => {
        if (error) {
          reject(error);
        } else if (data) {
          resolve(filter(data, city => isBangalore(city.id))); // @todo remove once fixed from backend
        } else {
          resolve(null);
        }
      }
    );
  });
}

export function getCityByLocation(options = {}) {
  const { latitude, longitude } = options;
  if (!latitude || !longitude) return Promise.reject(new Error('LatLng should not be empty'));

  return new Promise((resolve, reject) => {
    APIService.request(
      {
        method: 'GET',
        url: `${API_HOST}${apiEndpoints.CITIES}?lat=${latitude}&lng=${longitude}`,
      },
      (error, data) => {
        if (error) {
          reject(error);
        } else if (data) {
          resolve(data);
        } else {
          resolve(null);
        }
      }
    );
  });
}

export function getCityBySearchTerm(options = {}) {
  const { searchTerm } = options;
  if (!searchTerm) return Promise.reject(new Error('search Term should not be empty'));

  return new Promise((resolve, reject) => {
    APIService.request(
      {
        method: 'GET',
        url: `${API_HOST}${apiEndpoints.CITIES}?name=${searchTerm}`,
      },
      (error, data) => {
        if (error) {
          reject(error);
        } else if (data) {
          resolve(data);
        } else {
          resolve(null);
        }
      }
    );
  });
}

export function getLocalitiesByCity(options = {}) {
  const { city } = options;
  if (!city) return Promise.reject(new Error('City should not be empty'));

  return new Promise((resolve, reject) => {
    APIService.request(
      {
        method: 'GET',
        url: `${API_HOST}${apiEndpoints.LOCALITIES}?cityId=${city}`,
      },
      (error, data) => {
        if (error) {
          reject(error);
        } else if (data) {
          resolve(data);
        } else {
          resolve(null);
        }
      }
    );
  });
}

export function getLocalitiesByLocation(options = {}) {
  const { city, latitude, longitude } = options;
  if (!city) return Promise.reject(new Error('City should not be empty'));
  if (!latitude || !longitude) return Promise.reject(new Error('LatLng should not be empty'));

  return new Promise((resolve, reject) => {
    APIService.request(
      {
        method: 'GET',
        url: `${API_HOST}${apiEndpoints.LOCALITIES}?cityId=${city}lat=${latitude}&lng=${longitude}`,
      },
      (error, data) => {
        if (error) {
          reject(error);
        } else if (data) {
          resolve(data);
        } else {
          resolve(null);
        }
      }
    );
  });
}

export default {};
